// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen` from
// x-flags.doRenderReactQueryQueryHook on POST /standings/get.

import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import type {
  typeStandingsGetBody,
  typeStandingsGetOutput200,
} from "../../sdk/standings/postStandingsGet";
import useCallSdk from "../../sdk-helpers/useCallSdk";

export function buildStandingsGetQueryKey(
  payload: typeStandingsGetBody,
): string[] {
  const queryKeySegments: string[] = [];
  queryKeySegments.push(`leagueId:${JSON.stringify(payload.leagueId)}`);
  queryKeySegments.push(`grouping:${JSON.stringify(payload.grouping)}`);
  return ["post:standings:standingsGet", "svc:sports-api", ...queryKeySegments];
}

type QueryOptions = Partial<
  UseQueryOptions<
    typeStandingsGetOutput200,
    unknown,
    typeStandingsGetOutput200,
    string[]
  >
> & {
  // Isolates two callers that query the same data for independent UI state
  // (e.g. a dropdown search vs a table both listing the same resource).
  queryKeyIdentifier?: string;
};

export default function useStandingsGet(
  payload: typeStandingsGetBody,
  options?: QueryOptions,
) {
  // No staleTime default here on purpose. Freshness is the consuming app's
  // decision and belongs in its QueryClient, in one place: a default set on the
  // hook would silently beat it for every screen. Pass one per call to override.
  const resolvedOptions = options ?? {};

  let queryKey = buildStandingsGetQueryKey(payload);
  if (resolvedOptions.queryKeyIdentifier) {
    queryKey = [...queryKey, resolvedOptions.queryKeyIdentifier];
  }

  const { callSdk } = useCallSdk();
  return useQuery({
    queryKey,
    queryFn: () => callSdk().postStandingsGet(payload),
    ...resolvedOptions,
  });
}
